import { toLocalISOStringWithOffset } from '../../../functions/local-time';

export const FORM_SCAN_INCENTIVE = ({ onEnter, branchOption }) => {
  const span = 24;
  return [
    {
      name: 'employeeId',
      label: 'เลขบัตรประจำตัวประชาชน',
      type: 'INPUT',
      disabled: true,
      span,
    },
    {
      name: 'branchId',
      label: 'ชื่อสาขา',
      type: 'DROPDOWN',
      properties: {
        options: branchOption || [],
      },
      span,
    },
    {
      name: 'barcodeValue',
      label: 'เลขที่ใบเสร็จ',
      type: 'INPUT_BARCODE',
      rules: {
        required: true,
      },
      onEnter,
      span,
    },
    {
      name: 'slipImage',
      label: 'รูปอ้างอิง',
      type: 'UPLOAD',
      span,
    },
    {
      name: 'scanTimestamp',
      label: 'Timestamp',
      type: 'INPUT',
      disabled: true,
      defaultValue: toLocalISOStringWithOffset(),
      span,
    },
  ];
};
